const commentsData = [
  {
    avatar: 'ri-user-heart-line',
    name: '小糖豆',
    time: '3天前',
    content: '和男朋友在情侣影院追完了《你比星光美丽》全集，每天晚上窝在一起看两集，真的太甜了！画质很清晰，完全不卡顿，推荐给所有情侣！',
    likes: 286,
  },
  {
    avatar: 'ri-user-star-line',
    name: '追剧二人组',
    time: '5天前',
    content: '终于找到能一起看的韩剧全集了！《眼泪女王》中字全集上线很快，和老婆一口气刷了八集，情侣影院的分类做得特别贴心，直接找甜宠就行。',
    likes: 193,
  },
  {
    avatar: 'ri-user-smile-line',
    name: '温暖的小窝',
    time: '1周前',
    content: '情侣影院真的改变了我俩的周末习惯！以前各看各的手机，现在每周五晚上固定一起追一部国产剧，感情反而更好了。片库很全，国产剧全集基本都有。',
    likes: 157,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            追剧心得
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            真实情侣用户的追剧体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 border border-secondary-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.avatar} text-lg`}></i>
                </div>
                <div>
                  <div className="font-heading text-sm font-bold text-foreground-700">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">{item.content}</p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-heart-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}